import { render, staticRenderFns } from "./supplierTaxIdInput.vue?vue&type=template&id=1310381e"
import script from "./supplierTaxIdInput.vue?vue&type=script&lang=js"
export * from "./supplierTaxIdInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports